import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { CustomMUIButton } from '../../components/commons/buttons/CustomMUIButton';
import { ButtonClassNames, GlobalRouteNames } from '../../models/Common';
import { ApiError } from '../../models/ApiError';
import { userInfoApi } from '../../services/apiServices/user/userInfo';
import { useCustomSnackbar } from '../../hooks/useCustomEnqueueSnackbar';
import { AnimatedIcon } from '../../components/commons/AnimatedIcon';
import SuccessIconLight from '../../assets/images/lottieIcons/success/success.light.json';
import SuccessIconDark from '../../assets/images/lottieIcons/success/success.dark.json';
import { getErrorMessage } from '../../utils';

export const SuccessAddAccount = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();
  const { search } = useLocation();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const [verifyAccount] = userInfoApi.useVerifyMemberAccountMutation();
  const queryParams = new URLSearchParams(search);

  const handleClick = () => {
    history.push(GlobalRouteNames.HomePage);
  };

  const confirmAccount = async (code: string) => {
    try {
      await verifyAccount({ code }).unwrap();
    } catch (err: unknown) {
      const error = err as ApiError;
      if (error.status === 400) {
        history.replace(GlobalRouteNames.TimeOutError);
      } else if (error.status === 409) {
        history.replace(GlobalRouteNames.HomePage);
      } else {
        const message = getErrorMessage(err);
        customEnqueueSnackbar(message, 'error');
      }
    }
  };

  useEffect(() => {
    if (queryParams.has('code')) {
      confirmAccount(String(queryParams.get('code'))).then(() => {
        setIsLoading(false);
      });
    } else {
      history.push({
        pathname: GlobalRouteNames.UnknownError,
        state: { message: '404.invalidLink' },
      });
    }
  }, []);

  return (
    <div className="success_page page">
      <div className="success_page__container container">
        <div className="success_page__icon-container">
          <AnimatedIcon
            lightIcon={SuccessIconLight}
            darkIcon={SuccessIconDark}
            className="success_page__icon-container__icon"
          />
        </div>
        <div className="success-container">
          <h1 className={isLoading ? 'skeleton' : 'skeleton--disabled'}>
            {t('success.balanceHasBeenReplenishedSuccessfully')}
          </h1>
          <p className={isLoading ? 'skeleton' : 'skeleton--disabled'}>{t('multiAccount.accountAdded')}</p>
          <CustomMUIButton
            label={t('buttons.toMain')}
            handleClick={handleClick}
            className={ButtonClassNames.PrimaryFulfilled}
            isBold
            isDisabled={isLoading}
          />
        </div>
      </div>
    </div>
  );
};
